import { QueryModelAccessor } from '@mode/legacy/data-access-model-js';
import * as angular from 'angular';

/*
 * Report State Service
 *
 * Handles all fetching of report state on the report view page
 *
 */
export class ReportStateService {
  private report: any;
  private reportDeferred: any;
  private reportRun: any;
  private reportRunDeferred: any;
  private notebook: any;
  private notebookDeferred: any;
  private datasetsDeferred: any;
  // dataset is stored by datasetservice so no need to store it
  private datasetsUpdated: boolean;

  static $inject = [
    '$rootScope',
    'DatasetService',
    'PythonVisualizationModel',
    '$q',
    'ModeCollection',
    'QueryModel',
    'RxStoreService',
  ];

  constructor(
    private $rootScope,
    private DatasetService,
    private PythonVisualizationModel,
    private $q,
    private ModeCollection,
    private queryModelAccessor: QueryModelAccessor,
    private RxStoreService
  ) {
    this.reportDeferred = $q.defer();
    this.reportRunDeferred = $q.defer();
    this.datasetsDeferred = $q.defer();
    this.notebookDeferred = $q.defer();
  }

  resetState() {
    this.setReport();
    this.setReportRun();
    this.setDatasets();
    this.setNotebook();
  }

  setReport(report?) {
    if (!report) {
      this.report = null;
      this.reportDeferred = this.$q.defer();
      this.reportDeferred.promise.catch(() => {});
    } else {
      this.report = report;
      this.reportDeferred.resolve(this.report);
    }
  }

  getReport() {
    if (!this.report) {
      return this.reportDeferred.promise;
    } else {
      return this.$q.resolve(this.report);
    }
  }

  setReportRun(reportRun?) {
    if (!reportRun) {
      this.reportRun = null;
      this.reportRunDeferred = this.$q.defer();
      this.reportRunDeferred.promise.catch(() => {});
    } else {
      this.reportRun = reportRun;
      this.reportRunDeferred.resolve(this.reportRun);
    }
  }

  getReportRun() {
    if (!this.reportRun) {
      return this.reportRunDeferred.promise;
    } else {
      return this.$q.resolve(this.reportRun);
    }
  }

  getReportAndReportRun() {
    return this.$q.all([this.getReport(), this.getReportRun()]);
  }

  setDatasets(datasets?) {
    if (!datasets) {
      // resetting dataset since its undefined
      this.datasetsUpdated = false;
      this.datasetsDeferred = this.$q.defer();
      this.datasetsDeferred.promise.catch(() => {});
    } else {
      this.datasetsUpdated = true;
      this.datasetsDeferred.resolve(datasets);
    }
  }

  getDatasets() {
    if (!this.datasetsUpdated) {
      return this.datasetsDeferred.promise;
    } else {
      return this.$q.resolve(this.DatasetService.datasets);
    }
  }

  getNotebook() {
    if (!this.notebook) {
      return this.notebookDeferred.promise;
    } else {
      return this.$q.resolve(this.notebook);
    }
  }

  setNotebook(notebook?) {
    if (!notebook) {
      this.notebook = null;
      this.notebookDeferred = this.$q.defer();
      this.notebookDeferred.promise.catch(() => {});
    } else {
      this.notebook = notebook;
      this.notebookDeferred.resolve(this.notebook);
    }
  }

  rejectNotebook(e: Error) {
    if (this.notebookDeferred) {
      this.notebookDeferred.reject(e);
    }
  }

  // Helper Functions
  getReportQueries() {
    return this.getReport().then((report) => report.queries().then(this.ModeCollection.elements));
  }

  getQueryVisualizations(): angular.IPromise<any> {
    return this.getReport().then((report) =>
      report
        .queries()
        .then(this.ModeCollection.elements)
        .then((queries) => this.queryModelAccessor.buildQueriesWithVisualizations(queries))
    );
  }
}
